// agreement-handler.js

class CartAgreementHandler extends HTMLElement {
  constructor() {
    super();
    // Привязываем обработчики к контексту класса
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.updateCheckoutState = this.updateCheckoutState.bind(this);
  }

  // Метод, который вызывается при подключении элемента к DOM (в том числе после AJAX-обновления)
  connectedCallback() {
    // Получаем элементы
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.checkoutButton = document.getElementById(this.dataset.checkoutId);
    this.cartForm = document.getElementById(this.dataset.formId);
    // Нацеливаемся на все контейнеры динамических кнопок
    this.dynamicButtonsContainers = document.querySelectorAll('.cart__dynamic-checkout-buttons'); 

    if (!this.checkbox || !this.checkoutButton) {
      return; 
    }

    this.updateCheckoutState();

    // Добавляем слушателя событий (сначала удаляем, чтобы избежать дублирования при AJAX-загрузке)
    this.checkbox.removeEventListener('change', this.updateCheckoutState);
    this.checkbox.addEventListener('change', this.updateCheckoutState);

    // Дополнительная проверка на событие submit формы
    if (this.cartForm) {
      this.cartForm.removeEventListener('submit', this.handleFormSubmit);
      this.cartForm.addEventListener('submit', this.handleFormSubmit);
    }
  }

  // Обновление состояния кнопки
  updateCheckoutState() {
    const isChecked = this.checkbox.checked;

    // Блокировка/разблокировка основной кнопки
    this.checkoutButton.disabled = !isChecked;

    // Деактивация всех динамических кнопок
    this.dynamicButtonsContainers.forEach(container => {
        container.style.opacity = isChecked ? '1' : '0.5';
        container.style.pointerEvents = isChecked ? 'auto' : 'none';
    });
  }
  
  // Функция для обработки отправки формы
  handleFormSubmit(event) {
    if (!this.checkbox.checked) {
      event.preventDefault(); 
      alert('I have read and agree to the license terms'); 
      this.checkbox.focus(); 
    }
  }
}

// Регистрируем новый пользовательский элемент
customElements.define('cart-agreement-handler', CartAgreementHandler);